



// import React from 'react';
// import './CourseCard.css';

// const courses = [
//   {
//     category: 'Indoor',
//     title: 'Engineering Class',
//     image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
//     oldPrice: 69,
//     newPrice: 49,
//     description: 'Nascetur ridiculus mus mauris vitae ultricies leo. Eget arcu dictum varius duis at.',
//     rating: 4,
//     reviewCount: 1,
//     startDate: '18 Sep'
//   },
//   {
//     category: 'Indoor',
//     title: 'Engineering Class',
//     image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
//     oldPrice: 69,
//     newPrice: 49,
//     description: 'Nascetur ridiculus mus mauris vitae ultricies leo. Eget arcu dictum varius duis at.',
//     rating: 4,
//     reviewCount: 1,
//     startDate: '18 Sep'
//   },
//   {
//     category: 'Indoor',
//     title: 'Engineering Class',
//     image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
//     oldPrice: 69,
//     newPrice: 49,
//     description: 'Nascetur ridiculus mus mauris vitae ultricies leo. Eget arcu dictum varius duis at.',
//     rating: 4,
//     reviewCount: 1,
//     startDate: '18 Sep'
//   },
//   {
//     category: 'Indoor',
//     title: 'Engineering Class',
//     image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
//     oldPrice: 69,
//     newPrice: 49,
//     description: 'Nascetur ridiculus mus mauris vitae ultricies leo. Eget arcu dictum varius duis at.',
//     rating: 4,
//     reviewCount: 1,
//     startDate: '18 Sep'
//   },
//   {
//     category: 'Indoor',
//     title: 'Engineering Class',
//     image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
//     oldPrice: 69,
//     newPrice: 49,
//     description: 'Nascetur ridiculus mus mauris vitae ultricies leo. Eget arcu dictum varius duis at.',
//     rating: 4,
//     reviewCount: 1,
//     startDate: '18 Sep'
//   },
//   {
//     category: 'Indoor',
//     title: 'Engineering Class',
//     image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
//     oldPrice: 69,
//     newPrice: 49,
//     description: 'Nascetur ridiculus mus mauris vitae ultricies leo. Eget arcu dictum varius duis at.',
//     rating: 4,
//     reviewCount: 1,
//     startDate: '18 Sep'
//   },
//   {
//     category: 'Indoor',
//     title: 'Engineering Class',
//     image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
//     oldPrice: 69,
//     newPrice: 49,
//     description: 'Nascetur ridiculus mus mauris vitae ultricies leo. Eget arcu dictum varius duis at.',
//     rating: 4,
//     reviewCount: 1,
//     startDate: '18 Sep'
//   },
//   {
//     category: 'Indoor',
//     title: 'Engineering Class',
//     image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
//     oldPrice: 69,
//     newPrice: 49,
//     description: 'Nascetur ridiculus mus mauris vitae ultricies leo. Eget arcu dictum varius duis at.',
//     rating: 4,
//     reviewCount: 1,
//     startDate: '18 Sep'
//   },
//   // Add other courses here...
// ];

// const CourseCard = () => (
//   <div>
//   <h1 className='cousre'>Courses</h1>
//   <div className="container">
    
//     {courses.map((course, index) => (
//       <div key={index} className="dtlms-courselist-item-wrapper">
//         <div className="dtlms-courselist-thumb">
//           <a href="./a-for-apple/courses/engineering-class/" title={course.title}>
//             <img src={course.image} alt={course.title} />
//           </a>
//         </div>
//         <div className="dtlms-courselist-details">
//           <p className="dtlms-courselist-tags">
//             <a href="./a-for-apple/course-category/indoor/" rel="tag">{course.category}</a>
//           </p>
//           <div className="dtlms-courselist-title-section">
//             <h5>
//               <a href="./a-for-apple/courses/engineering-class/">{course.title}</a>
//             </h5>
//             <div className="dtlms-coursedetail-price-details">
//               <span className="dtlms-price-status dtlms-cost">
//                 <del>
//                   <span className="woocommerce-Price-amount amount">${course.oldPrice}</span>
//                 </del>
//                 <ins>
//                   <span className="woocommerce-Price-amount amount">${course.newPrice}</span>
//                 </ins>
//               </span>
//             </div>
//           </div>
//           <div className="dtlms-courselist-description">{course.description}</div>
//           <div className="dtlms-courselist-bottom-section">
//             <div className="dtlms-courselist-bottom-left-section">
//               <div className="dtlms-courselist-ratings-container">
//                 <p className="dtlms-courselist-ratings">
//                   {Array.from({ length: 5 }, (_, i) => (
//                     <span
//                       key={i}
//                       className={i < course.rating ? 'zmdi zmdi-star' : 'zmdi zmdi-star-outline'}
//                       data-value={i + 1}
//                     />
//                   ))}
//                 </p>
//                 <p className="dtlms-courselist-overall-ratings">
//                   {course.rating}
//                   <span className="dtlms-courselist-total-reviews">{course.reviewCount} Review{course.reviewCount > 1 ? 's' : ''}</span>
//                 </p>
//               </div>
//             </div>
//             <div className="dtlms-courselist-bottom-right-section">
//               <div className="dtlms-coursedetail-cart-details dtlms-coursedetail-notes">
//                 <a href="#" className="dtlms-button small filled dtlms-disabled">Starts On : {course.startDate}</a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     ))}
//   </div>
//   </div>
// );

// export default CourseCard;



import React, { useState } from 'react';
import './CourseCard.css';

const courses = [
  {
    category: 'Indoor',
    title: 'Indoor Games',
    image: './a-for-apple/wp-content/uploads/sites/2/2024/02/course-detail-image-105.jpg',
    description: 'Our indoor games foster teamwork and critical thinking, providing a fun and safe environment for children to develop their problem-solving skills and social interactions.',
    // rating: 4,
    // reviewCount: 1,
    // startDate: '18 Sep'
  },
  {
    category: 'Dance',
    title: 'Western Dance',
    image: './dance.jpg',
    // oldPrice: 79,
    // newPrice: 59,
    description: 'Dance classes at our school encourage creativity and physical fitness, helping children express themselves through movement while improving their coordination and rhythm..',
    // rating: 5,
    // reviewCount: 2,
    // startDate: '20 Sep'
  },
  {
    category: 'Music',
    title: 'Music Class',
    image: './Musicc.jpg',
    // oldPrice: 69,
    // newPrice: 49,
    description: 'Music classes introduce children to the joy of rhythm and melody, fostering an appreciation for different sounds and instruments while boosting cognitive and emotional development..',
    // rating: 4,
    // reviewCount: 1,
    // startDate: '18 Sep'
  },
  {
    category: 'Craft',
    title: 'Painting Class',
    image: './craft.jpg',
    description: 'Craft sessions inspire creativity and fine motor skills, allowing children to explore different materials and techniques to create their own masterpieces..',
    
  },
  {
    category: 'Language',
    title: 'Math League',
    image: './language.jpg',
    description: 'Language activities focus on building strong communication skills, with engaging exercises that enhance vocabulary, listening, and speaking abilities in a fun and interactive way..',
  },
  
  {
    category: 'Craft',
    title: 'Art Club',
    image: './Crafttt.jpg',
    description: 'Craft sessions inspire creativity and fine motor skills, allowing children to explore different materials and techniques to create their own masterpieces..',
    
  },
  {
    category: 'Sports',
    title: 'Kids Playing Club',
    image: './sports.jpg',
    description: 'Our sports activities promote healthy competition and physical well-being, ensuring that children develop essential motor skills and a love for an active lifestyle.',
  
  },
  {
    category: 'Music',
    title: 'Orchestra Player',
    image: './music.jpg',
    // oldPrice: 69,
    // newPrice: 49,
    description: 'Music classes introduce children to the joy of rhythm and melody, fostering an appreciation for different sounds and instruments while boosting cognitive and emotional development..',
    // rating: 4,
    // reviewCount: 1,
    // startDate: '18 Sep'
  },
  // Add other courses here...
];

const CourseCard = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const filteredCourses = selectedCategory === 'All'
    ? courses
    : courses.filter(course => course.category === selectedCategory);

  return (
    <div>
      <h1 className='cousre'>Courses</h1>
      <div className="category-tabs">
        {['All', 'Craft', 'Dance', 'Indoor', 'Language', 'Music', 'Sports'].map(category => (
          <button
            key={category}
            onClick={() => handleCategoryChange(category)}
            className={`category-tab ${selectedCategory === category ? 'active' : ''}`}
          >
            {category}
          </button>
        ))}
      </div>
      <div className="container con">
        {filteredCourses.map((course, index) => (
          <div key={index} className="dtlms-courselist-item-wrapper">
            <div className="dtlms-courselist-thumb">
              <a href="./a-for-apple/courses/engineering-class/" title={course.title}>
                <img src={course.image} alt={course.title} />
              </a>
            </div>
            <div className="dtlms-courselist-details">
              <p className="dtlms-courselist-tags">
                <a href="./a-for-apple/course-category/indoor/" rel="tag">{course.category}</a>
              </p>
              <div className="dtlms-courselist-title-section">
                <h5>
                  <a href="./a-for-apple/courses/engineering-class/">{course.title}</a>
                </h5>
                <div className="dtlms-coursedetail-price-details">
                  {/* <span className="dtlms-price-status dtlms-cost">
                    <del>
                      <span className="woocommerce-Price-amount amount">${course.oldPrice}</span>
                    </del>
                    <ins>
                      <span className="woocommerce-Price-amount amount">${course.newPrice}</span>
                    </ins>
                  </span> */}
                </div>
              </div>
              <div className="dtlms-courselist-description">{course.description}</div>
              <div className="dtlms-courselist-bottom-section">
                <div className="dtlms-courselist-bottom-left-section">
                  <div className="dtlms-courselist-ratings-container">
                    {/* <p className="dtlms-courselist-ratings">
                      {Array.from({ length: 5 }, (_, i) => (
                        <span
                          key={i}
                          className={i < course.rating ? 'zmdi zmdi-star' : 'zmdi zmdi-star-outline'}
                          data-value={i + 1}
                        />
                      ))}
                    </p> */}
                    <p className="dtlms-courselist-overall-ratings">
                      {course.rating}
                      {/* <span className="dtlms-courselist-total-reviews">{course.reviewCount} Review{course.reviewCount > 1 ? 's' : ''}</span> */}
                    </p>
                  </div>
                </div>
                <div className="dtlms-courselist-bottom-right-section">
                  <div className="dtlms-coursedetail-cart-details dtlms-coursedetail-notes">
                    {/* <a href="#" className="dtlms-button small filled dtlms-disabled">Starts On : {course.startDate}</a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseCard;
